<template>
  <div class="d-flex h-100 w-100 justify-content-center login-container">
    <div class="align-self-center">
      <div class="card login-panel">
        <div class="card-header">User Registration
        </div>
        <div class="card-body">
          <b-form-group
            label="Username" label-for="username">
            <b-form-input :state="validations.username.messages.length === 0" aria-describedby="username-required"
                          ref="usernameInput" id="username"
                          v-model="username" required
                          placeholder="Enter username"
            ></b-form-input>
            <b-form-feedback id="username-required">
              {{validations.username.messages.join(',')}}
            </b-form-feedback>
          </b-form-group>
          <div class="row">
          <b-form-group class="col-6 no-padding"
            label="Firstname" label-for="firstname">
            <b-form-input ref="firstnameInput" id="firstname"
                          v-model="firstname"
                          placeholder="Enter firstname"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="col-6 no-padding"
            label="Family name" label-for="lastname">
            <b-form-input ref="lastnameInput" id="lastname"
                          v-model="lastname"
                          placeholder="Enter lastname"
            ></b-form-input>
          </b-form-group>
        </div><!-- end .row -->
          <b-form-group
            label="Email" label-for="email">
            <b-form-input :state="validations.email.messages.length === 0" type="email" ref="emailInput" id="email"
                          v-model="email" required
                          aria-describedby="email-required"
                          placeholder="Enter email"
            ></b-form-input>
            <b-form-feedback id="email-required">
              {{validations.email.messages.join(',')}}
            </b-form-feedback>
          </b-form-group>
          <div class="row">
          <b-form-group class="col-6 no-padding"
            label="Password" label-for="password">
            <b-form-input :state="validations.password.messages.length === 0" type="password" ref="passwordInput"
                          id="password"
                          v-model="password" required
                          placeholder="Enter password"
                          aria-describedby="password-required"
            ></b-form-input>
            <b-form-feedback id="password-required">
              {{validations.password.messages.join(',')}}
            </b-form-feedback>
          </b-form-group>
          <b-form-group class="col-6 no-padding"
            label="Password repeat" label-for="passrep">
            <b-form-input :state="validations.passrep.messages.length === 0" type="password" ref="passrepInput"
                          id="passrep"
                          v-model="passrep" required
                          placeholder="Repeat password"
                          aria-describedby="passrep-required"
            ></b-form-input>
            <b-form-feedback id="passrep-required">
              {{validations.passrep.messages.join(',')}}
            </b-form-feedback>
          </b-form-group>
        </div><!--end .row -->
        </div>
        <div class="card-footer">
          <div class="register-footer">
            <button-group class="btn-block btn-group">
            <b-button class="main-cancel-button" :disabled="loading" @click="cancel">Cancel</b-button>
            <b-button class="main-action-button" :disabled="loading || !isAllValid()" @click.stop.prevent="onSubmit" type="submit">Submit</b-button>
          </button-group>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import router from '../../router'
  export default {
    name: 'reset-password',
    data () {
      return {
        passrep: '',
        password: '',
        username: '',
        lastname: '',
        firstname: '',
        email: '',
        loading: false,
        validations: {
          username: {
            messages: []
          },
          email: {
            messages: []
          },
          password: {
            messages: []
          },
          passrep: {
            messages: []
          }
        }
      }
    },
    methods: {
      isAllValid () {
        for (let k in this.validations) {
          if (this.validations.hasOwnProperty(k)) {
            if (this.validations[k].messages.length > 0) {
              return false
            }
          }
        }
        return true
      },
      validateForm (clbValid) {
        if (!this.validateEmail(this.email)) {
          this.validations['email'].messages.push('Incorrect email')
        }

        if (!this.validateUsername(this.username)) {
          this.validations['username'].messages.push('Only alpha-numeric symbols and dot(.) are allowed')
        }

        if (this.password.length < 4 || this.password.length > 12) {
          this.validations['password'].messages.push('Password should have at least 4 and at most 12 symbols')
        }

        if (this.password !== this.passrep) {
          this.validations['passrep'].messages.push('Passwords do not match')
        }

        this.loading = true
        this.$http.get('/api/user-exists?username=' + this.username)
          .then(res => {
            this.loading = false
            if (res.body.status) {
              this.validations['username'].messages.push('Username already registered')
            } else {
              this.loading = false
              if (this.isAllValid()) {
                clbValid.call(this)
              }
            }
          }, res => {})
      },
      validateEmail (email) {
        let re = /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/

        return re.test(email)
      },
      validateUsername (username) {
        return /^[a-zA-Z0-9.]+$/.test(username)
      },
      onSubmit () {
        this.validateForm(() => {
          let formData = new FormData()
          formData.append('password', this.password)
          formData.append('username', this.username)
          formData.append('email', this.email)
          formData.append('firstname', this.firstname)
          formData.append('lastname', this.lastname)
          this.loading = true
          this.$http.post('/api/register', formData)
            .then(res => {
              this.$notify({
                title: 'SUCCESS',
                text: 'We sent activation email to KEGS adminstrator. You will be notified when the account is activated.',
                type: 'success'
              })
              this.loading = false
              setTimeout(() => {
                router.push('/')
              }, 1000)
            }, res => {
              this.$notify({
                title: 'ERROR',
                text: 'Could not register.',
                type: 'error'
              })
              this.loading = false
            })
        })
      },
      cancel () {
        location.href = '/'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/Registration.vue